export default __webpack_public_path__ + "static/media/photo--sm--kate.46ab5238.jpg";